import { render } from "./FileModal.vue?vue&type=template&id=56812690"
import script from "./FileModal.vue?vue&type=script&lang=js"
export * from "./FileModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/settings/FileModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56812690"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56812690', __exports__)) {
    api.reload('56812690', __exports__)
  }
  
  module.hot.accept("./FileModal.vue?vue&type=template&id=56812690", () => {
    api.rerender('56812690', render)
  })

}


export default __exports__